import React from 'react';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '../ui/select';
import { QUESTION_TITLE_MAX, QUESTION_BODY_MAX } from '../../lib/communityValidation';

const Counter = ({ value, max }) => {
  const len = (value || '').trim().length;
  return (
    <span className={`text-xs font-mono ${len > max ? 'text-destructive' : 'text-muted-foreground'}`}>
      {len}/{max}
    </span>
  );
};

// Shared by the Ask dialog (CommunityPage) and the inline edit form (QuestionDetailPage).
// value: { title, description, category }; errors: { title?, description? }
const QuestionFormFields = ({ value, errors = {}, categories, onChange, idPrefix = 'question' }) => {
  const set = (field) => (e) => onChange({ ...value, [field]: e.target ? e.target.value : e });

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}-category`}>Category</Label>
        <Select value={value.category} onValueChange={set('category')}>
          <SelectTrigger id={`${idPrefix}-category`} data-testid={`${idPrefix}-category-select`}>
            <SelectValue placeholder="Choose a category" />
          </SelectTrigger>
          <SelectContent>
            {categories.map((c) => (
              <SelectItem key={c.key} value={c.key}>{c.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label htmlFor={`${idPrefix}-title`}>Title</Label>
          <Counter value={value.title} max={QUESTION_TITLE_MAX} />
        </div>
        <Input
          id={`${idPrefix}-title`}
          value={value.title}
          onChange={set('title')}
          placeholder="e.g. Why does my BMS report a cell imbalance after fast charging?"
          aria-invalid={!!errors.title}
          data-testid={`${idPrefix}-title-input`}
        />
        {errors.title && <p className="text-xs text-destructive">{errors.title}</p>}
      </div>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label htmlFor={`${idPrefix}-description`}>Description</Label>
          <Counter value={value.description} max={QUESTION_BODY_MAX} />
        </div>
        <Textarea
          id={`${idPrefix}-description`}
          value={value.description}
          onChange={set('description')}
          placeholder="Vehicle/ECU, what you've tried, exact DTCs or error messages..."
          rows={6}
          aria-invalid={!!errors.description}
          data-testid={`${idPrefix}-description-input`}
        />
        {errors.description && <p className="text-xs text-destructive">{errors.description}</p>}
      </div>
    </div>
  );
};

export default QuestionFormFields;
